export default __webpack_public_path__ + "static/media/Vote1.70eb7695.png";